import { Type } from 'typebox';
import { Attachment } from '../reference/attachment.js';
import { createFallbackStringEnumCodec } from '../../utils/fallback-string-enum-codec.js';
export const InstantMessageTypes = {
    text: 'text',
    event: 'event',
    unknown: 'unknown'
};
export const InstantMessageType = Type.Union([
    Type.Literal(InstantMessageTypes.text),
    Type.Literal(InstantMessageTypes.event),
    Type.Literal(InstantMessageTypes.unknown)
]);
export const InstantMessageTypeCodec = createFallbackStringEnumCodec(InstantMessageTypes, InstantMessageTypes.unknown);
export const InstantMessageRoles = {
    parent: 'parent',
    teacher: 'teacher',
    admin: 'admin',
    unknown: 'unknown'
};
export const InstantMessageRole = Type.Union([
    Type.Literal(InstantMessageRoles.parent),
    Type.Literal(InstantMessageRoles.teacher),
    Type.Literal(InstantMessageRoles.admin),
    Type.Literal(InstantMessageRoles.unknown)
]);
export const InstantMessageRoleCodec = createFallbackStringEnumCodec(InstantMessageRoles, InstantMessageRoles.unknown);
const EventKeyOnly = Type.Object({
    key: Type.String({ minLength: 1 })
});
export const InstantMessage = Type.Object({
    id: Type.String({ minLength: 1 }),
    v: Type.Optional(Type.Integer()),
    clientUpdateTimestamp: Type.Number(),
    captureTimestamp: Type.Number(),
    deleted: Type.Boolean(),
    authorKey: Type.String({ minLength: 1 }),
    authorId: Type.Optional(Type.String({ minLength: 1 })),
    role: InstantMessageRoleCodec,
    authorName: Type.Optional(Type.String()),
    text: Type.Optional(Type.String()),
    attachments: Type.Array(Attachment),
    event: Type.Optional(EventKeyOnly),
    type: InstantMessageTypeCodec,
    obsId: Type.Optional(Type.String({ minLength: 1 }))
});
